import Loading from "components/center-loading";
import InformAdvanceDelayOrder from 'components/inform-advance-delay-order'
import SnackBar from 'material-ui/Snackbar'
import moment from "moment";
import PropTypes from "prop-types";
import React, { Component } from "react";
import intl from "react-intl-universal";
import { calculatePalletsQuantityByTotal, calculateQuantityPerTruck } from "utils/calculations";
import { formatErrorMessage } from "utils/handle-error";
import SessionUser from 'utils/user-storage'
import { isLoadCompositionFlowBrewerySide } from "utils/validations-general-settings";
import DangerDialog from "../danger-dialog";

import Orders from "./orders";
import {
  cancelBalance,
  cancelOrder,
  changeRequest,
  requestOrderCancellation,
  searchCardDetail,
} from "./orders.service";
import PendingVolum from "./pendingVolum";

const TipoPedidoTransferencia = 2;

class OrdersVolum extends Component {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        familyId: PropTypes.string,
        itemId: PropTypes.string,
        typeNeed: PropTypes.string,
        date: PropTypes.string,
        datetype: PropTypes.string,
      }),
    }),
    showVolumes: PropTypes.bool,
    fetchData: PropTypes.func,
    handleSearchDailyDeliveries: PropTypes.func,
  };

    constructor(props) {
      super(props);

      this.state = {
        estoqueDetalhe: null,
        chartData: {
          Details: [],
          guides: {},
        },
        lastOrderOpen: {
          index: {},
          tableListBodyElement: {},
        },
        pedido: {},
        showFeedback: false,
        messageFeedback: "",
        requestCount: 0,
        idFamiliaRotuladaCentro: parseInt(props.match.params.familyId),
        date: props.match.params.date,
        datetype: parseInt(props.match.params.datetype),
        idPedidoCancelamento: null,
        showCancelConfirm: false,
        showCompositionOrders: false,
        showFormOrder: false,
        justificationMessages: [],
        searchTimeLine: false,
        idJustificativaCancelamento: null,
        indexOrigem: null,
        statusPedidoEmCancelamento: null,
        isNewFlow: isLoadCompositionFlowBrewerySide(),
        linhaProducaoCentro: [],
      };
    }

    async componentDidMount() {
      this.loadCompletePage();
    }

    async loadCompletePage() {
      this.setState({
        searchTimeLine: true,
      });

      await this.getOrders();
    }

    async getOrders() {
      const { idFamiliaRotuladaCentro, date, datetype } = this.state;

      this.handleFetch();

    const estoqueDetalhe = await this.loadCardDetail(idFamiliaRotuladaCentro, date, datetype);
    this.setState({
      estoqueDetalhe,
    });

      this.searchMessages();
      this.handleFetch(false);
    }

    async loadCardDetail(idFamiliaRotuladaCentro, date, datetype) {
      try {
        const fetcher = this.props.fetchData || searchCardDetail;
        const data = await fetcher(idFamiliaRotuladaCentro, date, datetype);
        return data;
      } catch (err) {
        this.showFeedback(intl.get("orders.feedback.errorBringingOrders"));
      }
    }

    async saveOrder(item) {
      const alteracaoPedido = {
        IdPedido: item.Id,
        ResponsavelEntrega: item.ResponsavelEntrega,
        HoraEntrega: item.HoraEntrega,
        Total: item.Total,
        RequirementCode: item.RequirementCode,
      };

      this.handleFetch();

    try {
      const data = await changeRequest(alteracaoPedido);
      if (data) {
        this.showFeedback(intl.get("orders.feedback.orderSavedSuccessfully"));
        this.loadCompletePage();
      } else this.showFeedback(intl.get("stocks.timeline.feedback.noChangeOrder"));
    } catch (err) {
      this.showFeedback(formatErrorMessage(err));
      console.log(err);
    } finally {
      if (this.props.handleSearchDailyDeliveries) this.props.handleSearchDailyDeliveries();
      this.handleFetch(false);
    }
  }

    async cancelarSaldoPedidoVolume(itemVolume, indexOrigem) {
      const user = SessionUser.get();

      this.handleFetch();

    try {
      const _body = {
        userId: user.Id,
        labeledFamilyCenterId: this.state.idFamiliaRotuladaCentro,
      };
      await cancelBalance(itemVolume.Id, _body);
      this.showFeedback(intl.get("stocks.timeline.feedback.volumeCanceledSuccessfully"));
      const pedidosVolume = this.state.estoqueDetalhe.ListaPedidosVolume;
      const remainingOrdersVolum = pedidosVolume[indexOrigem].PedidosVolume.filter(
        (item) => item.Id !== itemVolume.Id
      );
      let newPedidosVolume = pedidosVolume;
      newPedidosVolume[indexOrigem].PedidosVolume = remainingOrdersVolum;
      this.setState((prevState) => ({
        estoqueDetalhe: {
          ...prevState.estoqueDetalhe,
          ListaPedidosVolume: [...newPedidosVolume],
        },
      }));
    } catch (err) {
      console.error("Erro ao cancelar saldo do volume:", err);
      const errorMessage =
        err?.response?.data?.Message ||
        err?.message ||
        intl.get("stocks.timeline.feedback.thereProblemDeletingVolume");
      this.showFeedback(errorMessage);
    } finally {
      if (this.props.handleSearchDailyDeliveries) this.props.handleSearchDailyDeliveries();
      this.handleFetch(false);
    }
  }

    async searchMessages() {
      try {
        const data = JSON.parse(localStorage.getItem("enumerators"));
        this.proccessDataMessages(data.OrderCancellationJustifications);
      } catch (err) {
        this.showFeedback(formatErrorMessage(err));
      }
    }

    proccessDataMessages(data) {
      this.setState({
        justificationMessages: data,
      });
    }

    async handleConfirmRequestOrderCancellation(
      idJustificativaCancelamento,
      messageUserToSupplier,
      forcedCancel
    ) {
      const { idPedidoCancelamento, idFamiliaRotuladaCentro, indexOrigem } = this.state;
      const listaPedido = this.state.estoqueDetalhe.ListaPedidos;
      const pedido = listaPedido[indexOrigem].Pedidos.find(
        (item) => item.Id === idPedidoCancelamento
      );
      const user = SessionUser.get();

      this.handleFetch();
      this.closeCancelConfirm();
      try {
        const requestDto = {
          IdPedido: idPedidoCancelamento,
          MessageUser: messageUserToSupplier,
          IdJustificativa: idJustificativaCancelamento,
          IdUsuario: user.Id,
          IdFamiliaRotuladaCentro: idFamiliaRotuladaCentro,
          Pedido: pedido,
          ForcedCancel: forcedCancel,
        };
        await requestOrderCancellation(requestDto);

        const remainingOrders = listaPedido[indexOrigem].Pedidos.filter(
          (item) => item.Id !== idPedidoCancelamento
        );
        let pedidos = listaPedido;
        pedidos[indexOrigem].Pedidos = remainingOrders;

      this.setState((prevState) => ({
        indexOrigem: null,
        lastOrderOpen: {
          index: {},
          tableListBodyElement: {},
        },
        estoqueDetalhe: {
          ...prevState.estoqueDetalhe,
          ListaPedidos: [...pedidos],
        },
      }));
      this.showFeedback(intl.get("stocks.timeline.feedback.orderCanceledSuccessfully"));
    } catch (e) {
      this.showFeedback(formatErrorMessage(e));
    }
    if (this.props.handleSearchDailyDeliveries) this.props.handleSearchDailyDeliveries();
    this.handleFetch(false);
  }

    async cancelarPedido(idJustificativaCancelamento, messageUserToSupplier, forcedCancel) {
      if (this.state.pedido?.PedidoOriginadoVolume) {
        this.closeCancelConfirm();
        this.showCompositionOrders(idJustificativaCancelamento);
      } else {
        const idPedidoCancelamento = this.state.idPedidoCancelamento;
        const listaPedido = this.state.estoqueDetalhe.ListaPedidos;
        const pedido = listaPedido[this.state.indexOrigem].Pedidos.find(
          (item) => item.Id === idPedidoCancelamento
        );

        const orderDto = {
          Id: pedido.Id,
          OrderType: pedido.TipoPedido,
          OrderStatus: pedido.IntStatus,
          TypeJustificationManualSuggestion: idJustificativaCancelamento,
        };

        this.handleFetch();
        try {
          await cancelOrder(orderDto, forcedCancel, messageUserToSupplier);
          this.showFeedback(intl.get("stocks.timeline.feedback.orderCanceledSuccessfully"));
          this.closeCancelConfirm();

          const remainingOrders = listaPedido[this.state.indexOrigem].Pedidos.filter(
            (item) => item.Id !== idPedidoCancelamento
          );

        let pedidos = listaPedido;
        pedidos[this.state.indexOrigem].Pedidos = remainingOrders;
        this.setState((prevState) => ({
          indexOrigem: null,
          lastOrderOpen: {
            index: {},
            tableListBodyElement: {},
          },
          estoqueDetalhe: {
            ...prevState.estoqueDetalhe,
            ListaPedidos: [...pedidos],
          },
        }));
      } catch (err) {
        this.showFeedback(formatErrorMessage(err));
      } finally {
         if (this.props.handleSearchDailyDeliveries) this.props.handleSearchDailyDeliveries();
        this.handleFetch(false);
      }
    }
  }

    showCancelConfirm = (item, indexOrigem) => {
      this.setState({
        showCancelConfirm: true,
        idPedidoCancelamento: item.Id,
        indexOrigem: indexOrigem,
        statusPedidoEmCancelamento: item.IntStatus,
      });
    };

    closeCancelConfirm = () => {
      this.setState({ showCancelConfirm: false });
    };

    showCompositionOrders = (idJustificativaCancelamento) => {
      this.setState({ showCompositionOrders: true, idJustificativaCancelamento });
    };

    showFormOrder = (item) => {
      const pedidoObj = {
        NumeroPedido: item.Id,
        NumeroPedidoSap: item.CodigoPedidoSAP,
        NumeroItemPedidoSap: item.CodigoItemPedidoSap,
        DesabilitarDataColeta: item.IntStatus === 8,
        DataColeta: moment(item.Coleta).format("L"),
        DataEntrega: moment(item.DataEntregaDe).format("L"),
        DataCriacao: item.DataCriacao,
        PossuiComposicao: item.PossuiComposicao,
        TransitTime: item.TransitTime,
        PedidoOriginadoVolume: item.PedidoOriginadoVolume,
        HoraEntrega: item.HoraEntrega,
        Quantidade: item.Total,
        Material: item.Material.MaterialPesquisa,
        UnidadeMedida: item.UnidadeMedida,
        IdFornecedor: item.IdFornecedor,
        IntStatus: item.IntStatus,
        TipoPedido: item.TipoPedido,
        NegociacaoPedido: item.NegociacaoPedido,
        IsBreweryTransfer: item.IsBreweryTransfer,
      };

      this.setState({
        showFormOrder: true,
        pedido: pedidoObj,
      });
    };

    closeFormOrder = () => {
      this.setState({ showFormOrder: false });
    };

  salvarNovasDatasColetaEntrega = () => {
     this.showFeedback(intl.get("stocks.timeline.feedback.editOrder"));
    this.setState(
      {
        showFormOrder: false,
      },
      () => {
        this.loadCompletePage();
        if (this.props.handleSearchDailyDeliveries) this.props.handleSearchDailyDeliveries();
      }
    );
  };

    usuarioComPermissaoParaCancelarPedidos = (possuiPermissao) => {
      this.setState({
        possuiPermissao,
      });
    };

    calcTimelineMaxHeight = () => {};

    showFeedback = (message) => {
      this.setState({
        showFeedback: true,
        messageFeedback: message,
      });
    };

    closeFeedback = () => {
      this.setState({ showFeedback: false });
    };

    handleFetch = (isFetching = true) => {
      this.setState((prevState) => ({
        requestCount: isFetching ? prevState.requestCount + 1 : prevState.requestCount - 1,
      }));
    };

    formatFields = (name, value, item) => {
      switch (name) {
        case "Quantidade": {
          const calculatedAmount = calculateQuantityPerTruck(
            value,
            item.QuebraEntrega,
            item.QuantidadeLote
          );
          return {
            ...item,
            Quantidade: calculatedAmount.QuantityPallets,
            Total: calculatedAmount.Total,
            QuantidadeCarros: calculatedAmount.TrucksQuantity,
          };
        }
        case "Total": {
          const calculatedAmount = calculatePalletsQuantityByTotal(
            value,
            item.QuebraEntrega,
            item.QuantidadeLote
          );
          return {
            ...item,
            Quantidade: calculatedAmount.QuantityPallets,
            Total: calculatedAmount.Total,
            QuantidadeCarros: calculatedAmount.TrucksQuantity,
          };
        }
        default: {
          return {
            ...item,
            [name]: value,
          };
        }
      }
    };

    changeValueOrder = (name, value, item, indexOrigem) => {
      const {
        estoqueDetalhe: { ListaPedidos },
      } = this.state;

      const indexItem = ListaPedidos[indexOrigem].Pedidos.findIndex((x) => x.Id === item.Id);

      const order = this.formatFields(name, value, item);

      let pedidos = ListaPedidos;
      pedidos[indexOrigem].Pedidos[indexItem] = order;

      this.setState((state) => ({
        estoqueDetalhe: {
          ...state.estoqueDetalhe,
          ListaPedidos: [...pedidos],
        },
      }));
    };

    render() {
      const { showVolumes } = this.props;
    const shouldShowVolumes = showVolumes === undefined ? true : showVolumes;
    const shouldShowPendingVolum =
      shouldShowVolumes || this.state.estoqueDetalhe?.Periodicidade === TipoPedidoTransferencia;

      return (
        <div>
          <Loading fullHeightParent isLoading={this.state.requestCount > 0} />
          {this.state.estoqueDetalhe && (
            <React.Fragment>
              <Orders
                data={{ ...this.state }}
                calcTimelineMaxHeight={this.calcTimelineMaxHeight}
                showCancelConfirm={this.showCancelConfirm}
                showFormOrder={this.showFormOrder}
                changeValueOrder={this.changeValueOrder}
                saveOrder={this.saveOrder.bind(this)}
                usuarioComPermissaoParaCancelarPedidos={this.usuarioComPermissaoParaCancelarPedidos}
                isNewFlow={this.state.isNewFlow}
                linhaProducaoCentro={this.state.linhaProducaoCentro}
                isHourlyPlan={this.state.estoqueDetalhe?.IsHourlyPlan}
              />
              {shouldShowPendingVolum  && (
                <PendingVolum
                  data={{ ...this.state }}
                  calcTimelineMaxHeight={this.calcTimelineMaxHeight}
                  showCancelConfirm={this.showCancelConfirm}
                  showFormOrder={this.showCancelConfirm}
                  cancelarSaldoPedidoVolume={this.cancelarSaldoPedidoVolume.bind(this)}
                />
              )}
            </React.Fragment>
          )}
          {this.state.showFormOrder && (
            <InformAdvanceDelayOrder
              open
              pedido={this.state.pedido}
              onClose={this.closeFormOrder}
              onSave={this.salvarNovasDatasColetaEntrega}
              labeledFamilyCenterPeriodicity={this.state.estoqueDetalhe?.Periodicidade ?? 0}
            />
          )}
          <SnackBar
            message={this.state.messageFeedback}
            open={this.state.showFeedback}
            autoHideDuration={3000}
            onRequestClose={this.closeFeedback}
          />

          <DangerDialog
            show={this.state.showCancelConfirm}
            title={intl.get("stocks.timeline.feedback.confirmCancelOrder")}
            labelButton={intl.get("stocks.suggestionsListItem.cancelOrder")}
            labelButtonClose={intl.get("stocks.suggestionsListItem.close")}
            handleConfirm={this.cancelarPedido.bind(this)}
            handleClose={this.closeCancelConfirm}
            justificationMessages={this.state.justificationMessages}
            statusPedidoEmCancelamento={this.state.statusPedidoEmCancelamento}
            handleConfirmRequestOrderCancellation={this.handleConfirmRequestOrderCancellation.bind(
              this
            )}
            isLoading={this.state.requestCount > 0}
          />
        </div>
      );
    }
}

export default OrdersVolum
